export const cleanHtmlContent = htmlContent => {
    if (!htmlContent || typeof htmlContent !== "string") {
        return htmlContent;
    }

    try {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlContent;

        // Remove TODOS os spans de forma recursiva
        // let spans;
        // while ((spans = tempDiv.querySelectorAll("span")).length > 0) {
        //     spans.forEach(span => {
        //         if (span.parentNode) {
        //             const parent = span.parentNode;
        //             while (span.firstChild) {
        //                 parent.insertBefore(span.firstChild, span);
        //             }
        //             parent.removeChild(span);
        //         }
        //     });
        // }

        // Remove outros elementos problemáticos
        const problematicTags = ["font", "style"];
        problematicTags.forEach(tagName => {
            let elements;
            while ((elements = tempDiv.querySelectorAll(tagName)).length > 0) {
                elements.forEach(el => {
                    if (el.parentNode) {
                        const parent = el.parentNode;
                        while (el.firstChild) {
                            parent.insertBefore(el.firstChild, el);
                        }
                        parent.removeChild(el);
                    }
                });
            }
        });

        // MUDANÇA PRINCIPAL: Limpa atributos mas PRESERVA text-align
        tempDiv.querySelectorAll("*").forEach(el => {
            // Guarda o text-align se existir
            const textAlign = el.style.textAlign;

            // Remove todos os atributos problemáticos
            el.removeAttribute("class");
            el.removeAttribute("font");
            el.removeAttribute("color");
            el.removeAttribute("face");
            el.removeAttribute("size");

            // Limpa o style completamente
            //el.removeAttribute("style");

            // Re-aplica APENAS o text-align se existia
            if (textAlign && ["left", "center", "right", "justify"].includes(textAlign)) {
                el.style.textAlign = textAlign;
            }
        });

        // Remove tags vazias
        tempDiv.querySelectorAll("*:empty").forEach(el => {
            if (
                !["br", "hr", "img", "input", "area", "base", "col", "embed", "link", "meta", "source", "track", "wbr"].includes(
                    el.tagName.toLowerCase()
                )
            ) {
                el.remove();
            }
        });

        return tempDiv.innerHTML;
    } catch (error) {
        console.warn("Erro na limpeza DOM:", error);
        return htmlContent;
    }
};
